import httpApi from '../api/httpApi';
import {
    DocumentParams,
    DocumentResponse,
    DocumentUploadBody,
} from 'models/DocumentLibrary';
import useSWR from 'swr';
import { api } from 'utils/axios';

export const useAdminDocumentLibrary = () => {
    const BASE_URL = '/api/v1/document';

    const useAdminDocumentLibrarySWR = (params: DocumentParams) => {
        const fetcher = (query, params): Promise<DocumentResponse> => {
            return httpApi
                .get<DocumentResponse>(query, params)
                .then((res) => {
                    return res.getData();
                })
                .catch((error) => {
                    throw error;
                });
        };

        const { data, error, isLoading, mutate } = useSWR(
            [BASE_URL + '/list', params],
            ([url, params]) => fetcher(url, params),
            {
                dedupingInterval: 300000,
                errorRetryCount: 3,
            }
        );

        return {
            documents: data ? data : null,
            isLoading: isLoading,
            isError: error,
            forceRefresh: mutate,
        };
    };

    const downloadDocument = (id: string): Promise<Blob> => {
        return api
            .get(BASE_URL + '/' + id, { responseType: 'blob' })
            .then((res) => {
                return res.data;
            })
            .catch((error) => {
                throw error;
            });
    };

    const uploadDocument = (body: DocumentUploadBody): Promise<string> => {
        const formData = new FormData();
        formData.append('file', body.document);
        formData.append('description', body.description);
        formData.append('is_active', body.is_active);
        return httpApi
            .post<string>(BASE_URL, formData)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const updateDocument = (
        id: string,
        body: DocumentUploadBody
    ): Promise<string> => {
        const formData = new FormData();
        if (body.document) {
            formData.append('file', body.document);
        }
        formData.append('description', body.description);
        formData.append('is_active', body.is_active);
        return httpApi
            .put<string>(BASE_URL + '/' + id, formData)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const changeDocumentVisibility = (
        id: string,
        visibility: boolean
    ): Promise<string> => {
        return httpApi
            .post<string>(BASE_URL + `/${id}/status`, { visibility })
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const deleteDocument = (id: string): Promise<void> => {
        return httpApi
            .del<void>(BASE_URL + '/' + id)
            .then((res) => {})
            .catch((error) => {
                throw error;
            });
    };

    return {
        useAdminDocumentLibrarySWR,
        downloadDocument,
        uploadDocument,
        updateDocument,
        changeDocumentVisibility,
        deleteDocument,
    };
};
